import { ApiPartialDate } from "@/types/common.types.ts";

export enum ApiDateFilterMode {
  day = "day",
  date = "date",
}

export enum ApiDateFilterOperator {
  custom = "custom",
  preset = "preset",
}

export enum ApiDateFilterPreset {
  this_week = "this_week",
  last_week = "last_week",
  this_month = "this_month",
  last_month = "last_month",
  last_30_days = "last_30_days",
  last_3_months = "last_3_months",
  this_quarter = "this_quarter",
  last_quarter = "last_quarter",
  this_year = "this_year",
  last_year = "last_year",
  next_week = "next_week",
  next_month = "next_month",
  next_quarter = "next_quarter",
  next_year = "next_year",
}

export interface ApiDateFilter {
  mode: ApiDateFilterMode;
  operator: ApiDateFilterOperator;
  value_from?: ApiPartialDate | null;
  value_to?: ApiPartialDate | null;
  preset?: ApiDateFilterPreset | null;
}

export function serializeDateFilter(filter: ApiDateFilter | undefined): string | undefined {
  return filter ? JSON.stringify(filter) : undefined;
}

export function parseDateFilterParam(raw: unknown): ApiDateFilter | undefined {
  if (!raw) return undefined;
  if (typeof raw === "object") return raw as ApiDateFilter;
  if (typeof raw !== "string") return undefined;
  try {
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? (parsed as ApiDateFilter) : undefined;
  } catch {
    return undefined;
  }
}
